import { useQuery, useQueryClient } from '@tanstack/react-query'
import platformSubscriptionsApi, {
    type PlatformSubscriptionDto,
} from '@wtf/shared/api/platformSubscriptions'
import { useCurrentUser } from '@/hooks/useCurrentUser'

// Query keys
export const platformSubscriptionKeys = {
    all: ['platform-subscription'] as const,
    current: () => [...platformSubscriptionKeys.all] as const,
}

/**
 * Hook to get current user's platform subscription
 * This is the single source of truth for subscription data including try-on limits
 */
export function useCurrentSubscription() {
    const { isAuthenticated } = useCurrentUser()

    return useQuery<PlatformSubscriptionDto, Error>({
        queryKey: platformSubscriptionKeys.current(),
        queryFn: () => platformSubscriptionsApi.getCurrentSubscription(),
        enabled: isAuthenticated,
        staleTime: 0, // Always fetch fresh data
        refetchOnMount: 'always', // Force refetch when component mounts
    })
}

/**
 * Hook to invalidate platform subscription cache
 * Use this after operations that modify subscription state
 */
export function useInvalidatePlatformSubscription() {
    const queryClient = useQueryClient()

    return () => {
        queryClient.invalidateQueries({
            queryKey: platformSubscriptionKeys.current(),
        })
    }
}
